import { useCallback, useState } from "react"

/**
 * useState backed by localStorage. Reads the initial value from storage
 * and persists every update. Falls back to `defaultValue` when storage
 * is empty or unavailable (e.g. private browsing).
 */
export function usePersistedState(
  key: string,
  defaultValue: boolean
): [boolean, (value: boolean) => void] {
  const [value, setValue] = useState<boolean>(() => {
    if (typeof window === "undefined") return defaultValue
    const stored = localStorage.getItem(key)
    return stored !== null ? stored === "true" : defaultValue
  })

  const setPersisted = useCallback(
    (next: boolean) => {
      setValue(next)
      if (typeof window !== "undefined") {
        localStorage.setItem(key, String(next))
      }
    },
    [key]
  )

  return [value, setPersisted]
}
